/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
var AddressRemoveButton = function AddressRemoveButton(_ref) {
  var confirmRemove = _ref.confirmRemove,
    displayText = _ref.displayText,
    iconSize = _ref.iconSize,
    multi = _ref.multi,
    remove = _ref.remove,
    showRemove = _ref.showRemove,
    toggleRemove = _ref.toggleRemove,
    trashColor = _ref.trashColor;
  if (multi && remove) {
    return /*#__PURE__*/React.createElement("div", {
      className: "address-remove-buttons text-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: !showRemove ? 'address-remove-buttons__remove-text' : 'hidden'
    }, /*#__PURE__*/React.createElement("button", {
      className: displayText === null ? '' : 'address-flex-end',
      onClick: toggleRemove,
      type: "button",
      title: "Remove address",
      tabIndex: 0
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: "IconTrash",
      size: iconSize,
      color: trashColor
    }), displayText !== null && /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'inline-block',
        paddingLeft: '5px'
      }
    }, displayText))), /*#__PURE__*/React.createElement("div", {
      className: showRemove ? 'address-remove-buttons__remove-confirmation' : 'hidden'
    }, /*#__PURE__*/React.createElement("p", {
      className: "address-remove-buttons__question-text"
    }, "Are you sure you want to remove this address?"), /*#__PURE__*/React.createElement("div", {
      className: "address-remove-buttons__selects"
    }, /*#__PURE__*/React.createElement("button", {
      className: "address-remove-buttons__confirm-confirmation",
      onClick: confirmRemove,
      type: "button",
      tabIndex: 0
    }, "YES"), /*#__PURE__*/React.createElement("button", {
      className: "address-remove-buttons__cancel-confirmation",
      onClick: toggleRemove,
      type: "button",
      tabIndex: 0
    }, "NO"))));
  }
  return null;
};
AddressRemoveButton.propTypes = {
  confirmRemove: PropTypes.func.isRequired,
  displayText: PropTypes.string,
  iconSize: PropTypes.number,
  multi: PropTypes.bool.isRequired,
  remove: PropTypes.func,
  showRemove: PropTypes.bool.isRequired,
  trashColor: PropTypes.string,
  toggleRemove: PropTypes.func.isRequired
};
AddressRemoveButton.defaultProps = {
  displayText: null,
  iconSize: 20,
  trashColor: '#C5C8CC'
};
export default AddressRemoveButton;
//# sourceMappingURL=AddressRemoveButton.js.map